import React, { FC } from 'react';
import classNames from 'classnames';
import {
  BUTTON_SIZE_CLASSES,
  BUTTON_SIZES,
  BUTTON_STYLE_CLASSES,
  BUTTON_STYLES,
} from '@/components/ui/Buttons/utils';
import Spinner from '@/components/ui/Icons/Spinner';
import { CTA_COLORS } from '@/components/common/types';
import { getCTAStyles } from '@/components/utils';

export interface ButtonProps {
  ctaText: string | undefined;
  ctaColor?: CTA_COLORS;
  onClick?: () => void;
  classes?: string;
  id?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?:
    | BUTTON_SIZES.sm
    | BUTTON_SIZES.md
    | BUTTON_SIZES.lg
    | BUTTON_SIZES.none;
  style?: BUTTON_STYLES.primary | BUTTON_STYLES.secondary | BUTTON_STYLES.link;
  fullWidth?: boolean;
  form?: string;
  testId?: string;
  includeSpinner?: boolean;
}

const Button: FC<ButtonProps> = ({
  ctaText,
  ctaColor = CTA_COLORS.DEFAULT,
  onClick = () => null,
  classes = '',
  id,
  disabled = false,
  type = 'button',
  size = BUTTON_SIZES.md,
  style = BUTTON_STYLES.primary,
  fullWidth = false,
  form,
  testId,
  includeSpinner = false,
}) => {
  return (
    <button
      className={classNames(
        BUTTON_STYLE_CLASSES[style],
        BUTTON_SIZE_CLASSES[size],
        fullWidth ? 'w-full' : '',
        classes,
        style === BUTTON_STYLES.primary && getCTAStyles(ctaColor),
      )}
      type={type}
      onClick={onClick}
      id={id}
      disabled={disabled}
      form={form}
      data-testid={testId}
    >
      {ctaText || ''}
      {includeSpinner && <Spinner />}
    </button>
  );
};

export default React.memo(Button);
